/* eslint-disable prettier/prettier */
import { datetimeSettingService } from "../services/datetime-setting.service";

//const resource = "wblcategory";
export const datetimeSetting = {
  namespaced: true,
  state: {
    datetimeSetting: []
  },
  actions: {
    getdatetimeSetting({ commit }) {
      //debugger;
      datetimeSettingService.getdatetimeSetting().then(datetimeSetting => {
        commit("setdatetimeSetting", datetimeSetting);
      });
    },
  },
  mutations: {
    setWblCategories(state, datetimeSetting) {
      state.datetimeSetting = datetimeSetting;
    }
  }
};
